"use client";
import Image from "next/image";
import school from "@/assets/images/icon/school.svg";
import school2 from "@/assets/images/icon/school2.svg";
import school3 from "@/assets/images/icon/school3.svg";
import workshop from "@/assets/images/icon/store.svg";
import group from "@/assets/images/icon/Group2.svg";

const images = [group, school, workshop, school2, school3];

const BLockFeatureTwo = ({ data }: any) => {
  const facts = [1, 2, 3, 4, 5]
    .map((seq) => ({
      seq,
      fact: data.find(
        (el: any) =>
          el.attributes.Type === "Facts" && el.attributes.Sequence === seq,
      ),
      image: images[seq - 1],
    }))
    .filter((f) => f.fact);

  if (facts.length === 0) return null;

  return (
    <>
      <style>{`
        .stats-strip {
          background: linear-gradient(135deg, #3f41d1 0%, #2b2da0 100%);
          padding: 0;
          width: 100%;
        }
        .stats-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
          display: flex;
          flex-wrap: wrap;
        }
        .stat-item {
          flex: 1 1 160px;
          display: flex;
          align-items: center;
          gap: 0.875rem;
          padding: 1.4rem 1.25rem;
          border-right: 1px solid rgba(255,255,255,0.15);
          transition: background 0.2s;
        }
        .stat-item:last-child { border-right: none; }
        .stat-item:hover { background: rgba(255,255,255,0.08); }
        .stat-icon {
          width: 42px;
          height: 42px;
          flex-shrink: 0;
          background: rgba(255,255,255,0.15);
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 9px;
        }
        .stat-text-bold {
          font-size: 1rem;
          font-weight: 700;
          color: #fff;
          line-height: 1.3;
          font-family: Graphik, sans-serif;
        }
        .stat-text-light {
          font-size: 0.75rem;
          color: rgba(255,255,255,0.75);
          font-family: Graphik, sans-serif;
          line-height: 1.3;
        }
        @media (max-width: 640px) {
          .stat-item {
            flex: 1 1 45%;
            border-right: none;
            border-bottom: 1px solid rgba(255,255,255,0.12);
            padding: 1rem;
          }
          .stat-item:nth-child(odd) { border-right: 1px solid rgba(255,255,255,0.12); }
        }
      `}</style>

      <div className="stats-strip">
        <div className="stats-inner">
          {facts.map(({ seq, fact, image }) => {
            const lines: string[] = fact.attributes.Content.split("\n");
            return (
              <div key={seq} className="stat-item">
                <div className="stat-icon">
                  <Image
                    src={image}
                    alt={`stat-${seq}`}
                    width={24}
                    height={24}
                    style={{
                      objectFit: "contain",
                      filter: "brightness(0) invert(1)",
                    }}
                  />
                </div>
                <div>
                  <div className="stat-text-bold">{lines[0]}</div>
                  {lines.slice(1).map((line: string, i: number) => (
                    <div key={i} className="stat-text-light">
                      {line}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default BLockFeatureTwo;
